export const mediaKeys = {
  all: ['media'] as const,
  exports: (storyId: string) => [...mediaKeys.all, 'exports', storyId] as const,
};
